import type { ShipmentListRow } from './types';

export function initials(name: string): string {
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) {
        return '?';
    }
    if (parts.length === 1) {
        return parts[0].slice(0, 2).toUpperCase();
    }

    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function formatDateTime(iso: string | null): { date: string; time: string } {
    if (!iso) {
        return { date: '—', time: '' };
    }
    const d = new Date(iso.includes('T') ? iso : `${iso}T12:00:00`);
    return {
        date: d.toLocaleDateString('pt-BR', { day: 'numeric', month: 'long', year: 'numeric' }),
        time: d.toLocaleTimeString('pt-BR', { hour: 'numeric', minute: '2-digit' }),
    };
}

export function riskColor(level: string | null): string {
    if (level === 'Alto') {
        return 'bg-red-500';
    }
    if (level === 'Médio' || level === 'Medio') {
        return 'bg-amber-500';
    }
    if (level === 'Baixo') {
        return 'bg-emerald-500';
    }

    return 'bg-gray-300';
}

export function processStatusColor(status: string): string {
    if (status === 'Finalizado') {
        return 'bg-emerald-500';
    }
    if (status === 'Aberto') {
        return 'bg-blue-500';
    }

    return 'bg-gray-400';
}

export function exportShipmentsCsv(rows: ShipmentListRow[], filename: string): void {
    const header = [
        'ID',
        'Embarque',
        'Qtd pedidos',
        'Pedidos',
        'Clientes',
        'Fornecedor',
        'Data pedido',
        'Armador',
        'Estágio',
        'Status',
        'Risco',
        'Invoice',
    ];
    const lines = rows.map((r) =>
        [
            r.id,
            r.order_number,
            r.linked_deals_count ?? 0,
            (r.linked_deals ?? []).map((d) => d.label).join('; '),
            (r.clients_summary ?? []).join('; '),
            r.supplier_display?.label ?? r.supplier_label,
            r.order_date ?? '',
            r.shipping_line ?? '',
            r.stage_label,
            r.process_status,
            r.delay_risk_level ?? '',
            r.invoice ?? '',
        ]
            .map((v) => `"${String(v).replace(/"/g, '""')}"`)
            .join(','),
    );
    const csv = [header.join(','), ...lines].join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
}
